module.exports = __webpack_public_path__ + "d27963575f3475aac65d9a0285789e64.svg";